import type { ReactNode } from "react";

interface CategoryHeaderProps {
  title: string;
  description: string;
  icon: string;
  breadcrumb: ReactNode;
}

export default function CategoryHeader({ title, description, icon, breadcrumb }: CategoryHeaderProps) {
  return (
    <div className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-site px-4 py-8 md:px-6 md:py-10">
        <div className="mb-3">{breadcrumb}</div>
        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-600 text-2xl text-background-50">
            <i className={icon} aria-hidden="true"></i>
          </span>
          <div>
            <h1 className="font-heading text-2xl font-bold text-foreground-900 md:text-3xl">{title}</h1>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-500">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}